import React, { useEffect, createElement } from 'react';
import { ProfitMaximizerUpsell } from '../components/ProfitMaximizerUpsell';
export function Modulo3Page() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-1772">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-1773">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-1774">
          AI <span className="text-[#F5C842]" data-id="element-1775">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-1776">
          <a href="/modulo-0" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1777">
            Módulo 0
          </a>
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1778">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1779">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-1780">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1781">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-1782">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] pb-[50px]" data-id="element-1783">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-1784">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1785">
            Módulo 3 de 4
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-1786">
            ⏱ 20 minutos · Herramienta: Sales Letter Weapon
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-1787">
          La Demo que
          <br data-id="element-1788" />
          <span className="text-[#F5C842]" data-id="element-1789">Cierra Sola</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-1790">
          Cómo construir un sitio web profesional para tu prospecto en menos de
          10 minutos — antes de hablar con él. Cuando llegas con la demo lista,
          ya no eres un vendedor. Eres un consultor.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-1791">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1792">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1793"></div>
            Herramienta: Sales Letter Weapon en HEYLLOYD
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1794">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1795"></div>
            Demo lista en menos de 2 minutos
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1796">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1797"></div>5 demos
            listas para presentar
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-1798">
        {/* VIDEO */}
        <div className="mb-10" data-id="element-1799">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1800">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1801"></span>
            Video del Módulo
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-1802">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-1803">
              <iframe src="https://player.vimeo.com/video/1179701415?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSER Video 3" data-id="element-1804" />
            </div>
          </div>
        </div>

        {/* BUTTON MODULO 3 */}
        <div className="mt-4 mb-10" data-id="element-1805">
          <a href="https://app.heylloyd.io/share/lloyd/6f60b0db-b8a" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-1806">
            <span className="text-[20px]" data-id="element-1807">📝</span>
            Abrir Sales Letter Weapon en Heylloyd
            <span className="text-[18px] font-black" data-id="element-1808">→</span>
          </a>
        </div>

        {/* STRATEGY BANNER */}
        <div className="mb-8 rounded-r-lg border border-[#2a2a2a] border-l-[4px] border-l-[#F5C842] bg-gradient-to-br from-[#0d0d0d] to-[#111] px-[28px] py-[24px]" data-id="element-1809">
          <div className="mb-2 font-heading text-[16px] font-black text-[#F5C842]" data-id="element-1810">
            ⚡ La Estrategia que Cambia Todo
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1811">
            La razón por la que la mayoría falla vendiendo servicios digitales
            es que llegan con palabras:{' '}
            <strong className="text-white" data-id="element-1812">
              "Te puedo hacer un sitio web."
            </strong>{' '}
            El cliente no lo ve. No lo cree. Y no compra.
            <br data-id="element-1813" />
            <br data-id="element-1814" />
            Con este módulo, llegas a la llamada con el sitio web del cliente{' '}
            <strong className="text-white" data-id="element-1815">ya construido</strong>. El cliente lo
            ve, le gusta, y la venta se cierra sola. Tú no convences — tú
            muestras.
          </div>
        </div>

        {/* TOOL HIGHLIGHT */}
        <div className="mb-8 flex flex-col md:flex-row gap-6 items-start rounded-lg border border-[#2a2a2a] border-t-[3px] border-t-[#F5C842] bg-black p-7" data-id="element-1816">
          <div className="text-[48px] leading-none shrink-0" data-id="element-1817">🧠</div>
          <div data-id="element-1818">
            <div className="mb-1.5 text-[8px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1819">
              Heylloyd — Cerebro de IA
            </div>
            <div className="mb-2 font-heading text-[24px] font-black text-white" data-id="element-1820">
              Sales Letter Weapon
            </div>
            <div className="max-w-[700px] text-[13px] leading-[1.7] text-[#888]" data-id="element-1821">
              La IA que construye el sitio web del cliente en minutos. Le das la
              información básica del negocio y ella genera una página
              profesional completa, lista para presentar como demo antes de la
              llamada de venta.
            </div>
          </div>
        </div>

        {/* DEMO STEPS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1822">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1823"></span>
          Cómo Construir una Demo en 5 Pasos
        </div>
        <div className="mb-8 flex flex-col gap-3" data-id="element-1824">
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1825">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1826">
              1
            </div>
            <div data-id="element-1827">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1828">
                Abre Sales Letter Weapon en HEYLLOYD
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1829">
                Selecciona el cerebro "Sales Letter Weapon" desde tu panel de
                HEYLLOYD
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1830">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1831">
              2
            </div>
            <div data-id="element-1832">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1833">
                Ingresa el nombre del negocio
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1834">
                El nombre exacto del negocio que encontraste en el Módulo 2 con
                Ai Website Arbitrage
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1835">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1836">
              3
            </div>
            <div data-id="element-1837">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1838">
                Ingresa tipo de negocio, ciudad y servicios
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1839">
                Toda esta información ya la tienes de tu lista de prospectos del
                Módulo 2
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1840">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1841">
              4
            </div>
            <div data-id="element-1842">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1843">
                Ingresa el número de teléfono del negocio
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1844">
                La IA lo incluirá en la sección de contacto del sitio generado
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1845">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1846">
              5
            </div>
            <div data-id="element-1847">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1848">
                Copia y guarda el link de la demo
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1849">
                En menos de 2 minutos tendrás una página profesional lista para
                enviar al cliente
              </div>
            </div>
          </div>
        </div>

        {/* WHAT IT GENERATES */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1850">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1851"></span>
          Qué Genera Sales Letter Weapon Automáticamente
        </div>
        <div className="mb-8 grid grid-cols-2 gap-3 md:grid-cols-5" data-id="element-1852">
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1853">
            <div className="mb-2 text-[24px]" data-id="element-1854">🎨</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1855">
              Logo del negocio
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1856">
            <div className="mb-2 text-[24px]" data-id="element-1857">📝</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1858">
              Descripción de servicios
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1859">
            <div className="mb-2 text-[24px]" data-id="element-1860">🖼️</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1861">
              Galería de fotos
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1862">
            <div className="mb-2 text-[24px]" data-id="element-1863">📍</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1864">
              Sección de contacto y mapa
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1865">
            <div className="mb-2 text-[24px]" data-id="element-1866">📱</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1867">
              Diseño responsive móvil
            </div>
          </div>
        </div>

        {/* INFO NEEDED */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-1868">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1869">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1870">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1871"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1872">
                Información que necesitas del negocio
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1873">
              <ul className="flex flex-col" data-id="element-1874">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1875">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1876">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1877">Nombre del negocio</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1878">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1879">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1880">Tipo de negocio</strong>{' '}
                  (restaurante, peluquería, etc.)
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1881">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1882">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1883">Ciudad y dirección</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1884">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1885">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1886">Servicios que ofrece</strong>
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-1887">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1888">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1889">Número de teléfono</strong>
                </li>
              </ul>
              <br data-id="element-1890" />
              <em className="text-[11px] text-[#555]" data-id="element-1891">
                ✓ Todo esto lo encontraste en el Módulo 2 con Ai Website
                Arbitrage
              </em>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1892">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1893">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1894"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1895">
                ¿Tiene que ser perfecta la demo?
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1896">
              <strong className="text-white" data-id="element-1897">No.</strong> No tiene que ser
              perfecta. Tiene que ser{' '}
              <strong className="text-white" data-id="element-1898">
                profesional y mucho mejor que lo que tienen ahora
              </strong>
              . Eso es todo lo que necesitas para cerrar la venta.
              <br data-id="element-1899" />
              <br data-id="element-1900" />
              Cuando el cliente ve su negocio representado de forma profesional
              en pantalla, la conversación cambia completamente. Ya no estás
              vendiendo — estás{' '}
              <strong className="text-white" data-id="element-1901">
                mostrando el resultado final
              </strong>
              .
            </div>
          </div>
        </div>

        {/* SCRIPT */}
        <div className="mb-8" data-id="element-1902">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1903">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1904"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-1905">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1906">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1907"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1908">
              "Módulo 3. Este es el módulo que más me emociona enseñarte. Voy a
              mostrarte cómo construir un sitio web profesional para tu
              prospecto en menos de 10 minutos, antes de hablar con él. Cuando
              llegues a la llamada con una demo ya lista, la conversación cambia
              completamente. Ya no eres un vendedor. Eres un consultor que ya
              hizo el trabajo."
            </div>
          </div>

          <div className="mb-4" data-id="element-1909">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1910">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1911"></span>⏱
              0:30 – 15:00 · Demo en Pantalla
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1912">
              "Abre el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1913">
                'Sales Letter Weapon'
              </span>{' '}
              en HEYLLOYD. Vas a ver que te pide información básica del negocio:
              nombre, tipo de negocio, ciudad, servicios que ofrece y número de
              teléfono. Toda esa información la encontraste en el Módulo 2 con
              el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1914">
                'Ai Website Arbitrage'
              </span>
              ."{'\n\n'}
              "Rellena los campos con la información de tu primer prospecto.
              Ahora observa. En menos de 2 minutos, el cerebro genera una página
              web completa con: el logo del negocio, una descripción de sus
              servicios, una galería de fotos, y una sección de contacto con su
              teléfono y mapa."{'\n\n'}
              "¿Es perfecta? No. ¿Es profesional y mucho mejor que lo que tienen
              ahora? Absolutamente. Y eso es todo lo que necesitas para cerrar
              la venta."{'\n\n'}
              "Guarda el link de la demo. En el Módulo 4, te voy a enseñar
              exactamente qué decir cuando llames a este negocio."
            </div>
          </div>

          <div className="mb-4" data-id="element-1915">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1916">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1917"></span>⏱
              15:00 – 20:00 · Cierre y Tarea
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1918">
              "Tarea: construye una demo para cada uno de tus 5 prospectos.
              Guarda el link de cada una. Cuando tengas las 5 demos listas,
              estás listo para el Módulo 4 y para hacer tu primera venta."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-1919">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-1920">
            ✅ Tu Tarea — Módulo 3
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1921">
            Usa <strong className="text-white" data-id="element-1922">Sales Letter Weapon</strong> en
            HEYLLOYD y construye una demo para cada uno de tus{' '}
            <strong className="text-white" data-id="element-1923">5 prospectos</strong>. No hagas
            ninguna llamada sin tener la demo lista primero.
            <div className="mt-3 flex flex-col gap-2" data-id="element-1924">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1925">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1926">
                  1
                </div>
                Abre HEYLLOYD y selecciona el cerebro "Sales Letter Weapon"
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1927">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1928">
                  2
                </div>
                Ingresa la información del Prospecto #1 (nombre, tipo, ciudad,
                servicios, teléfono)
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1929">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1930">
                  3
                </div>
                Copia y guarda el link de la demo generada
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1931">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1932">
                  4
                </div>
                Repite para los 5 prospectos de tu lista
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1933">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1934">
                  5
                </div>
                <strong className="text-white" data-id="element-1935">
                  Cuando tengas las 5 demos listas, pasa al Módulo 4
                </strong>
              </div>
            </div>
          </div>
        </div>

        {/* PROFIT MAXIMIZER UPSELL */}
        <ProfitMaximizerUpsell data-id="element-1936" />
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-1937">
        <a href="/modulo-2" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] no-underline transition-colors hover:text-white" data-id="element-1938">
          ← Módulo 2
        </a>
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-1939">
          AI <span className="text-[#F5C842]" data-id="element-1940">WEB CLOSER</span>
        </div>
        <a href="/modulo-4" className="flex items-center gap-2 rounded bg-[#F5C842] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-85" data-id="element-1941">
          Módulo 4: El Cierre Sin Presión →
        </a>
      </div>
    </div>;
}